/* eslint-disable default-case */
import React from 'react';
import { connect } from "react-redux";
import styles from './SortFilter.module.css';
import PopupHeader from '../PopupHeader';
import { updateViewType } from '../../../../store/actions/notification';

const Toggle = (props) => {
    const { selected, toggleSelected } = props;
    return (
        <div className={styles.toggleContainer} onClick={toggleSelected}>
            <div className={[styles.dialogButton, selected ? "" : styles.disabled].join(" ")} />
        </div>
    );
}

class SortFilter extends React.Component<> {

    togglePrint = (type) => {
        const { dispatchUpdateViewType, reduxProps } = this.props;
        const { checkSortReducer } = reduxProps;
        const { data: { printGuestReceipt = true, printKitchenTicket = true, printFullOrder = true } } = checkSortReducer;
        if (type === 'guest') {
            dispatchUpdateViewType && dispatchUpdateViewType({ printGuestReceipt: !printGuestReceipt });
        } else if (type === 'kitchen') {
            dispatchUpdateViewType && dispatchUpdateViewType({ printKitchenTicket: !printKitchenTicket });
        } else if (type === 'order') {
            dispatchUpdateViewType && dispatchUpdateViewType({ printFullOrder: !printFullOrder });
        }
    }

    render() {
        const { onClose, sortFilter, setSortType, reduxProps } = this.props;
        const { checkSortReducer } = reduxProps;
        const { data: { printGuestReceipt = true, printKitchenTicket = true, printFullOrder = true } } = checkSortReducer;
        const sortOptions = [
            {
                text: 'Check Sort Order', leftLabel: 'Oldest first', rightLabel: 'Latest first', type: 'sort', selected: sortFilter, onPress: setSortType,
            },
            {
                text: 'Guest Receipt Print', leftLabel: 'Disabled', rightLabel: 'Enabled', type: 'guest', selected: printGuestReceipt, onPress: this.togglePrint,
            },
            {
                text: 'Kitchen Ticket Print', leftLabel: 'Disabled', rightLabel: 'Enabled', type: 'kitchen', selected: printKitchenTicket, onPress: this.togglePrint,
            },
            {
                text: 'Order Label Print', leftLabel: 'Disabled', rightLabel: 'Enabled', type: 'order', selected: printFullOrder, onPress: this.togglePrint,
            }
        ]
        return (
            <div className={styles.container}>
                <PopupHeader title={"SETTINGS"} onClose={onClose} containerStyle={styles.heading} />
                <div className={styles.bodyContainer}>
                    {
                        sortOptions.map((each) => {
                            return (
                                <div key={each.type} className={styles.toggleWrapper}>
                                    <span className={styles.textLable}>{each.text}</span>
                                    <div className={styles.toggleTextWrapper}>
                                        <span className={styles.sortOptions}>{each.leftLabel}</span>
                                        <Toggle selected={each.selected} toggleSelected={() => each.onPress(each.type)} />
                                        <span className={styles.sortOptions}>{each.rightLabel}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
};

const mapStateToProps = reduxProps => ({
    reduxProps,
});

const mapDispatchToProps = dispatch => ({
    dispatchUpdateViewType: (payload) => {
        dispatch(updateViewType(payload));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SortFilter);